<div class="dashboard__wrapper">
  <div class="dashboard__sidebar">
    <img class="logo" [routerLink]="['batches']" src="../../../assets/branding/Logo_sm.png">
    <ul>
      <li [routerLink]="['batches']" routerLinkActive="active" *ngIf="role != Role.Pilot">
        <i class="icon-batch"></i>
        <p><span>Batches</span></p>
      </li>
      <li [routerLink]="['accounts']" routerLinkActive="active"
          *ngIf="isAlpha">
        <i class="icon-accounts"></i>
        <p><span>Accounts</span></p>
      </li>

      <li [routerLink]="['lookup']" routerLinkActive="active"
          *ngIf="role == Role.Pilot || role == Role.Alpha || role == Role.Clerk || role == Role.Manager || role == Role.Trucker">
        <svg style="color:white;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25" fill="currentColor"
             class="active">
          <path
            d="M17 3.5H7C4 3.5 2 5 2 8.5V15.5C2 19 4 20.5 7 20.5H17C20 20.5 22 19 22 15.5V8.5C22 5 20 3.5 17 3.5ZM6.75 16C6.75 16.41 6.41 16.75 6 16.75C5.59 16.75 5.25 16.41 5.25 16V8C5.25 7.59 5.59 7.25 6 7.25C6.41 7.25 6.75 7.59 6.75 8V16ZM9.75 16C9.75 16.41 9.41 16.75 9 16.75C8.59 16.75 8.25 16.41 8.25 16V15C8.25 14.59 8.59 14.25 9 14.25C9.41 14.25 9.75 14.59 9.75 15V16ZM9.75 12C9.75 12.41 9.41 12.75 9 12.75C8.59 12.75 8.25 12.41 8.25 12V8C8.25 7.59 8.59 7.25 9 7.25C9.41 7.25 9.75 7.59 9.75 8V12ZM12.75 16C12.75 16.41 12.41 16.75 12 16.75C11.59 16.75 11.25 16.41 11.25 16V8C11.25 7.59 11.59 7.25 12 7.25C12.41 7.25 12.75 7.59 12.75 8V16ZM15.75 16C15.75 16.41 15.41 16.75 15 16.75C14.59 16.75 14.25 16.41 14.25 16V12C14.25 11.59 14.59 11.25 15 11.25C15.41 11.25 15.75 11.59 15.75 12V16ZM15.75 9C15.75 9.41 15.41 9.75 15 9.75C14.59 9.75 14.25 9.41 14.25 9V8C14.25 7.59 14.59 7.25 15 7.25C15.41 7.25 15.75 7.59 15.75 8V9ZM18.75 16C18.75 16.41 18.41 16.75 18 16.75C17.59 16.75 17.25 16.41 17.25 16V8C17.25 7.59 17.59 7.25 18 7.25C18.41 7.25 18.75 7.59 18.75 8V16Z"></path>
        </svg>
        <p><span>Lookup</span></p>
      </li>

      <li [routerLink]="['bookmarks']" routerLinkActive="active"
          *ngIf="role == Role.Pilot || role == Role.Alpha || role == Role.Clerk || role == Role.Manager || role == Role.Trucker">
        <i class="icon-bookmark"></i>
        <p><span>Bookmarks</span></p>
      </li>
    </ul>
  </div>
  <div class="dashboard__inner">
    <element-top-bar></element-top-bar>
    <div class="dashboard__content">
      <element-list-filter></element-list-filter>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<modal heading="Network Connection" [disable_exit]="true" [height]="330" [width]="450">
  <div style="text-align: center; line-height: 2em; padding:0 1em;">
    <div class="modal-top">
      <svg style="width: 73px;color: white;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
           stroke-width="1.5" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round"
              d="M8.288 15.038a5.25 5.25 0 017.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 011.06 0z"/>
      </svg>
    </div>
    <h2 style="margin-top: 13px;">Woops!</h2>
    <p style="margin: 0;">No Internet Connection found.<br> Check your connection or try again.</p>
    <p style="margin:0;">Once connection has been restored, please check batch for data loss.</p>
  </div>
</modal>


<modal heading="New Version" [disable_exit]="true" [height]="250" [width]="450">
  <div style="text-align: center; line-height: 2em; padding:0 1em;">
    <h2 style="margin-top: 13px;">New Version!</h2>
    <p style="margin: 0;">A new version of the platform has released. Please follow the steps below if you're running
      into any issues.</p>
    <ol style="margin: 0; padding:1em; text-align: left;">
      <li>Close all open browsers to ensure latest version is used.</li>
      <li>Lastly, login.</li>
      <li>Note: Do a regular refresh if this popup appears again.</li>
    </ol>
  </div>
</modal>
